'use strict';

import React from 'react';

/**
 * Get a synthetic react mouse event from a given native mouse event
 * @param nativeEvent
 * @param target
 */
export function createReactMouseEvent( nativeEvent: MouseEvent, target: HTMLElement ): React.MouseEvent {
    return Object.assign( {
        isDefaultPrevented: () => false,
        isPropagationStopped: () => false,
        persist: () => {
        },
        view: window,
        currentTarget: target,
        target: target,
        nativeEvent: nativeEvent
    }, nativeEvent );
}